import { FC } from "react"
import { Home } from "../../module/home/containers/home"

export const HomePage: FC = () => <Home />
